// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__MrTL1","main":"layout_main__E8fvu"};